import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import './SignIn.css'; // We will create this CSS file next

function SignIn() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const auth = getAuth();

    const handleSignIn = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
            // On successful sign-in, redirect the user to the admin dashboard
            navigate('/admin');
        } catch (err) {
            console.error("Sign-in error:", err);
            setError("Failed to sign in. Please check your email and password.");
        }
    };

    return (
        <div className="signin-container">
            <div className="signin-card">
                <h2>Admin & Researcher Sign-In</h2>
                <form onSubmit={handleSignIn}>
                    <div className="form-group">
                        <label>Email Address</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    <button type="submit">Sign In</button>
                </form>
            </div>
        </div>
    );
}

export default SignIn;
